import { Dimensions } from 'react-native';
import { isPhone, isIphoneX, isWeb } from './platform';

const { width, height } = Dimensions.get('window');
const [shortDimension, longDimension] = width < height ? [width, height] : [height, width];

const gcd = (a: number, b: number): number => {
  return b == 0 ? a : gcd(b, a % b);
};
const r = gcd(longDimension, shortDimension);

export const ratio = (longDimension / r / (shortDimension / r)).toFixed(2);
let guidelineBaseWidth: number;
let guidelineBaseHeight: number;
if (isPhone) {
  guidelineBaseWidth = isIphoneX || longDimension > 690 ? 414 : 360;
  guidelineBaseHeight = isIphoneX || longDimension > 690 ? 812 : 640;
} else {
  guidelineBaseWidth = Number(ratio) < 1.4 ? 1080 : 1152;
  guidelineBaseHeight = Number(ratio) < 1.4 ? 810 : 720;
}

const factor = shortDimension / guidelineBaseHeight;

const factorPhone = longDimension / guidelineBaseHeight;

export const scale = (size: number) => (isPhone ? size : (shortDimension / guidelineBaseWidth) * size);
export const verticalScale = (size: number) => (isPhone ? size : (longDimension / guidelineBaseHeight) * size);
export const moderateScale = (size: number) => (isWeb ? size : size * (isPhone ? factorPhone : factor));

export const s = scale;
export const vs = verticalScale;
export const ms = moderateScale;

export const loginBaseWidth = isPhone ? 360 : 440;

export const SCREEN_PADDING_HORIZONTAL = isPhone ? 15 : 18;

export const calculateTableConfig = ({
  width,
  scale,
  initialBaseSize = 324,
  spaceBetween = SCREEN_PADDING_HORIZONTAL,
  withoutHorizontalPaddings = false,
}: {
  width: number;
  scale: (size: number) => number;
  initialBaseSize?: number;
  spaceBetween?: number;
  withoutHorizontalPaddings?: boolean;
}) => {
  const minColoms = isPhone ? 1 : 2;
  const baseSize = scale(initialBaseSize);

  const devWidth = width || Dimensions.get('window').width;

  const possiableColumns = Math.floor(devWidth / baseSize);
  const columns = Math.max(minColoms, possiableColumns);
  const paddingHorizontal = !withoutHorizontalPaddings ? SCREEN_PADDING_HORIZONTAL * 2 : 0;

  const allSpaces = paddingHorizontal + scale(spaceBetween) * (columns - 1);

  const itemSize = (width - allSpaces) / columns;

  return {
    itemSize,
    columns,
  };
};
